import React from 'react';
import { CardFeatureA, CardFeatureB, CardFeatureC } from './widgets/Cards';

class Public extends React.Component {


    featureA() {

        var image = '/images/record.jpg';
        return (
            <CardFeatureB title='Comprehensive' subtitle='All care in one' imagelink={image}>
                Consolidate all types of care into one platform. <p></p>
                Reduce waste of time and paper.
                
            </CardFeatureB>
        )
    }

    featureB() {
        
        var image = '/images/group.jpg';
        return (
            <CardFeatureA title='Collaborative' subtitle='Working together' imagelink={image}>
                Practitioners team up with patients to achieve best care.<p></p>
                Integration with IOT devices at home.
                <p></p>
            </CardFeatureA>
        )
    }

    featureC() {
        
        var image = '/images/tracking.jpg';
        return (
            <CardFeatureA title='Intuitive' subtitle='Smart tracking system' imagelink={image} modaltitle="Intuitive" modalcontent='Coming soon'>
                Automatic warning, reminder, and S.M.A.R.T. Goal system.<p></p>
                Auto-notifcation for patient and practitioners.
                <p></p>
                
            </CardFeatureA>
        )
    }

    featureD() {
        
        var image = '/images/security.jpg';
        return (
            <CardFeatureC title='Protective' subtitle='Keep everything safe' imagelink={image}>
                7 Layers of data security.<p></p>
                Patient controls who can access their data.
                <p></p>
            </CardFeatureC>
        )
    }

    featureE() {

        var image = '/images/demographic.jpg';
        return (
            <CardFeatureB title='Descriptive' subtitle='Practitioner Dashboard' imagelink={image}>
                Data analysis of patient under care.<p></p>
                Prioritize patients with higher clinical needs.
            </CardFeatureB>
        )
    }

    featureF() {

        var image = './images/messaging.jpg';
        return (
            <CardFeatureA title='Communicative' subtitle='Direct link' imagelink={image}>
                Built-in messaging system.<p></p>
                Document sharing within care team 
            </CardFeatureA>
        )
    }

    footer() {

        return (
            <div style={{gridColumn :'span 2', lineHeight:'1.5', backgroundColor:'transparent', display:'grid', gridGap:'50px', gridTemplateColumns:"3fr 1fr 1fr 1fr", padding:'20px'}}>
                <div>
                    <h4>ABOUT</h4>
                    <div style={{color:'grey'}}>
                    Caredevo is a company thats focuses on community health care. Our vision is to improve chronic and complex health needs in the community by enhancing collaboration between health practitioners. 
                    We encourage patient's participation in their care through our platform.  
                    Our aim is to eliminate information silos and loss-of-tracking of patient care by using cloud-based multi-user role-based access permissioned technology. 
                    </div>

                </div>
                <div>
                    <h4>FOLLOW</h4>
                    <div style={{color:'grey', letterSpacing: '7px'}}>
                    <i class="fab fa-facebook fa-2x"></i>
                    <i class="fab fa-twitter fa-2x"></i>     
                    <i class="fab fa-linkedin-in fa-2x"></i>  
                   
                    
                    </div>

                </div>
                <div>
                    <h4>COMPANY</h4>
                    <div style={{color:'grey'}}>
                    About Us<br></br>
                    Contact Us<br></br>
                    Copyright<br></br>
                    Terms and Conditions <br></br>
                    Privacy Policy <br></br>
                    </div>
                </div>
                <div>
                    <h4>CONTACT US</h4>
                    <div style={{color:'grey'}}>
                    <label>Name</label><input size='30' placeholder='Type name' /><p></p>
                    <label>Email Address</label>
                    <input size='30' placeholder='Type email address' /><p></p>
                    <label>Message</label>
                    <textarea cols='33' rows='5' placeholder='Type in message'></textarea>
                    <button className='btnew'>Submit</button>
                    </div>
                </div>
                <div style={{color:'white', gridColumn:'span 4', margin:'20px -20px -20px -20px', padding:'12px', backgroundColor:'#1b2c3a', fontSize:'10px'}}>
                <center>Copyright @ 2020 All rights reserved by Caredevo</center>
                </div>
            </div>   
        )
    }

    content() {
        return (
            <div style={{display:'grid', gridGap:'10px', gridTemplateColumns:"1fr 1fr", gridTemplateRows:"1fr 1fr"}}>
                {this.featureA()}
                {this.featureB()}
                {this.featureC()}
                {this.featureD()}
                {this.featureE()}
                {this.featureF()}
                {this.footer()}
       
            
            </div> 
        )
    }



    render() {
        return (
            <div style={{margin : '100px 0px 0px 0px', fontFamily: "Arial, Helvetica, sans-serif", lineHeight:'0.8'}} >
                    <div style={{marginBottom:'40px'}}><center><img style={{width:'300px'}} src='./images/logo.png' alt='logo' /></center></div>
 
                    {this.content()}
            </div>
        );
    }
};


export default Public



// <center><h1 style={{ fontSize : '80px'}}>Caredevo<sup style={{ fontSize: '20px'}}>TM</sup></h1></center>
// <center><h3 style={{marginTop:'-40px', marginBottom:'50px'}}>Patient centered care</h3></center>